module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"These Job templates have been archived due to recent SOC code updates by the Home Office. They are for reference only and cannot be edited or used for new cases. Please use the \\"Job templates\\" tab for the latest versions or create new templates."}}')
  delete Component.options._Ctor
}
